module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgement"
    }
  }, [_c('h1', [_vm._v("Acknowledgement")]), _vm._v(" "), _c('p', [_vm._v("I would like to thank my husband for his support throughout this book and the first. I would also like to thank my children for their ongoing support and everyone who has encouraged me. Without them, this book would not have happened. I would like to thank Maska, the dog, who inspired me to build one of the characters on. I would like to thank David Pearce for his magic of the front cover and all the amazing pictures inside this book.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a817782","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 72
// module chunks = 0